import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import './Premiummarkets.scss'
import MarketOddBtn from '../MarketOddBtn/marketOddBtn';
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogContent, DialogTitle, IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { LimitDto, MarketGroup, MatchOdds } from '../../models/EventData';
import { Close, InfoOutlined, LockOutlined, PictureAsPdfOutlined } from '@mui/icons-material';
import ExpandLessSharp from '@mui/icons-material/ExpandLessSharp';
import { addExchangeBet } from '../../store/exchBetSlip/exchBetSlipAction';
import ExchBetSlip from '../ExchBetSlip/ExchBetSlip';
import { BsData } from '../../models/ExchBetSlip';
import CricketInplayRules from '../../assets/rules/CricketInplayRules.pdf';
import CricketPreMatchRules from '../../assets/rules/CricketPreMatchRules.pdf';
import SoccerInplayRules from '../../assets/rules/SoccerInplayRules.pdf';
import SoccerPreMatchRules from '../../assets/rules/SoccerPreMatchRules.pdf';
import TennisInplayRules from '../../assets/rules/TennisInplayRules.pdf';
import TennisPreMatchRules from '../../assets/rules/TennisPreMatchRules.pdf';
import { useTranslation } from '../../hooks/useTranslation';
import { UserDetails } from '../../models/UserDetails';

type StoreProps = {
  eventInfo: any;
  bets: BsData[];
  limits: LimitDto | undefined;
  addExchangeBet: (data: BsData) => void;
  isOneClickBettingEnabled: boolean;
  userDetails?: UserDetails;
  dynamicTextColors?: any;
};

type OddsInfoMsg = {
  launch: boolean;
  oddsType: string;
  eventTypeID: string;
};

const sportInplayRulesMap: any = {
  '4': [CricketInplayRules, CricketPreMatchRules],
  'sr:sport:21': [CricketInplayRules, CricketPreMatchRules],
  '1': [SoccerInplayRules, SoccerPreMatchRules],
  'sr:sport:1': [SoccerInplayRules, SoccerPreMatchRules],
  '2': [TennisInplayRules, TennisPreMatchRules],
  'sr:sport:5': [TennisInplayRules, TennisPreMatchRules],
};

const PremiumMarketsView: React.FC<StoreProps> = (props) => {
  const { t } = useTranslation();
  const {
    eventInfo,
    bets,
    limits,
    addExchangeBet,
    isOneClickBettingEnabled,
    userDetails,
    dynamicTextColors
  } = props;

  // Get dynamic text color classes from Redux instead of calling function
  const accordionHeaderTextColorClass = dynamicTextColors?.accordionHeaderTextColorClass || '';
  const tableRowTextColorClass = dynamicTextColors?.tableRowTextColorClass || '';

  // betLimitsTextColorClass uses same as accordionHeaderTextColorClass (both use --ion-background-color)
  const betLimitsTextColorClass = accordionHeaderTextColorClass;
  const [displayMarketGroups, setDisplayMarketGroups] = useState<MarketGroup[] | any>();

  const disabledStatus = [
    'deactivated',
    'suspended',
    'closed',
    'suspended-manually',
  ];
  const [selectedRow, setSelectedRow] = useState<string>('');
  const [infoDilalog, setInfoDialog] = useState<OddsInfoMsg>({
    launch: false,
    oddsType: "",
    eventTypeID: "",
  });


  useEffect(() => {
    if (eventInfo) {
      getAndSetMarkets(eventInfo?.markets?.premiumMarkets);
    } else {
      getAndSetMarkets([]);
    }
  }, [eventInfo]);

  const getAndSetMarkets = async (data: any) => {
    let newData: any = [];
    const marketDisableStatus = ["deactivated", "cancelled", "settled"];

    data?.reduce((oldV: any, newV: any) => {
      // show marketname in same order
      let index = oldV.findIndex((item: any) => item.marketName === newV.marketName);

      if (oldV.length && index !== -1) {
        let mrFound = false;
        for (let mr of oldV[index].completeMarket) {
          if (mr.marketId === newV.marketId) {
            mr = newV;
            mrFound = true;
          }
        }
        if (!mrFound) {
          oldV[index] = {
            ...oldV[index],
            completeMarket: [...oldV[index].completeMarket, newV],
          };
        }
      } else {
        // If a new market comes, it will be added to it.
        oldV.push({ marketName: newV.marketName, completeMarket: [newV] });
      }
      // return array.
      return oldV;
    }, newData);

    // sorting for runnername
    for (let i = 0; i < newData.length; i++) {
      newData[i].completeMarket.sort((a: any, b: any) => {
        let x = a.marketId;
        let y = b.marketId;
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    }

    // sorting based on market name
    if (newData?.length) {
      let data = newData
        .filter(
          (item: any) =>
            item.marketName === "1x2" ||
            item.marketName.toLowerCase().startsWith("winner") ||
            item.marketName === "Handicap" ||
            item.marketName === "Total"
        )
        .sort((a: any, b: any) => {
          let oldV = a.marketName.toLowerCase().startsWith("winner")
            ? "1x2"
            : a.marketName.toLowerCase();
          let newV = b.marketName.toLowerCase().startsWith("winner")
            ? "1x2"
            : b.marketName.toLowerCase();
          if (oldV < newV) return -1;
          if (oldV > newV) return 1;
          return 0;
        });

      let finalData = data.concat(newData);
      let temp: any = [];
      finalData.map((i: any, idx: any) => {
        i.completeMarket.map((j: any) => {
          if (!marketDisableStatus.includes(j?.status?.toLowerCase())) {
            temp.push(i);
          }
          return { ...j, runners: [...j.runners].sort((a, b) => a.runnerId - b.runnerId) };
        });
      });

      let temp1 = new Set(temp);
      setDisplayMarketGroups(Array.from(temp1));
    }

    if (eventInfo?.markets?.premiumMarkets?.length === 0) setDisplayMarketGroups([]);
  };

  return (
    <>
      <div className="premium-markets-table-ctn">
        <div className="pm-table-content table-ctn">
          {!["closed"].includes(eventInfo?.status?.toLocaleLowerCase()) ?
            displayMarketGroups &&
              displayMarketGroups.length > 0 ? (
              <>
                <div className={`bet-limits-section-prem ${betLimitsTextColorClass} ${betLimitsTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: betLimitsTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
                  {t("sports.min")}:{' '}
                  {limits?.minBetValue}{' '}
                  {t("sports.max")}:{' '}
                  {limits?.maxBetValue !== undefined
                    ? limits.maxBetValue % 1000 === 0
                      ? limits.maxBetValue / 1000 + "K"
                      : limits.maxBetValue
                    : ""}
                  {[
                    '4',
                    'sr:sport:21',
                    '1',
                    'sr:sport:1',
                    '2',
                    'sr:sport:5',
                  ]?.includes(eventInfo?.sportId) ? (
                    <Button
                      className="premium-rules-btn"
                      onClick={() =>
                        setInfoDialog({
                          launch: true,
                          oddsType: 'Premium',
                          eventTypeID: "",
                        })
                      }
                    >
                      <InfoOutlined />
                    </Button>
                  ) : null}
                </div>
                {displayMarketGroups?.map((pm: any, idx: any) =>
                  // pm  ? (
                  <Accordion
                    defaultExpanded={true}
                    className={`markets-accordian ${accordionHeaderTextColorClass} ${accordionHeaderTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandLessSharp className={`expand-icon ${accordionHeaderTextColorClass} ${accordionHeaderTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: accordionHeaderTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }} />
                      }
                      aria-controls="panel1a-content"
                      className={`${accordionHeaderTextColorClass} ${accordionHeaderTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}
                    >
                      <div className={`market-name ${accordionHeaderTextColorClass} ${accordionHeaderTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: accordionHeaderTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
                        {pm?.marketName}
                      </div>
                    </AccordionSummary>

                    <AccordionDetails>
                      <TableContainer className={tableRowTextColorClass}>
                        <Table className={`pm-table ${tableRowTextColorClass}`}>
                          <TableBody>
                            {pm?.completeMarket?.map((market: any, idx: any) => (
                              <>
                                {market.runners.map((runner: any, index: any) => (
                                  <>
                                    <PremiumMarketRow
                                      isOneClickBettingEnabled={isOneClickBettingEnabled}
                                      eventData={eventInfo}
                                      matchOddsData={pm}
                                      market={market}
                                      addExchangeBet={addExchangeBet}
                                      bets={bets}
                                      runner={runner}
                                      disabledStatus={disabledStatus}
                                      selectedRow={selectedRow}
                                      setSelectedRow={setSelectedRow}
                                      min={
                                        market?.limits?.minBetValue
                                          ? market?.limits?.minBetValue
                                          : 0
                                      }
                                      max={
                                        market?.limits?.maxBetValue
                                          ? market?.limits?.maxBetValue
                                          : 0
                                      }
                                      tableRowTextColorClass={tableRowTextColorClass}
                                    />
                                  </>
                                ))}
                              </>
                            )
                            )}

                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                  // ) : null
                )}
                <Dialog
                  open={infoDilalog?.launch}
                  onClose={() => setInfoDialog({ ...infoDilalog, launch: false })}
                  aria-labelledby="Settlements Dialog"
                  fullScreen={false}
                  fullWidth={true}
                  maxWidth="md"
                  className="stl-dialog rules-dialog"
                >
                  <DialogTitle className="stl-dialog-title">
                    <div className="title-close-icon">
                      <div className="modal-title notification-title">
                        {t("sports.rulesAndRegulations")}
                      </div>
                      <IconButton
                        className="close-btn"
                        onClick={() =>
                          setInfoDialog({ ...infoDilalog, launch: false })
                        }
                      >
                        <Close className="close-icon" />
                      </IconButton>
                    </div>
                  </DialogTitle>

                  <DialogContent className="stl-dialog-content premium-rules-pdf-ctn">
                    {sportInplayRulesMap[eventInfo?.sportId]?.map((file: string | undefined, idx: number) => (
                      <a href={file} className="premium-rules-pdf" target="_blank">
                        <PictureAsPdfOutlined />
                        {idx === 0
                          ? `${eventInfo?.sportName} ${t("sports.inplayRules")}`
                          : `${eventInfo?.sportName} ${t("sports.preMatchRules")}`}{' '}
                      </a>
                    ))}
                  </DialogContent>
                </Dialog>
              </>
            ) : null : null
          }
        </div>
      </div>
    </>
  );
};

type PremiumMarketRowProps = {
  eventData: any;
  matchOddsData: MatchOdds;
  runner: any;
  disabledStatus: string[];
  market: MatchOdds;
  bets: BsData[];
  addExchangeBet: (data: BsData) => void;
  selectedRow: string;
  setSelectedRow: (data: any) => void;
  min: number;
  max: number;
  isOneClickBettingEnabled: boolean;
  tableRowTextColorClass?: string;
};

export const PremiumMarketRow: React.FC<PremiumMarketRowProps> = (props) => {
  const {
    matchOddsData,
    runner,
    disabledStatus,
    eventData,
    market,
    bets,
    addExchangeBet,
    selectedRow,
    setSelectedRow,
    min,
    max,
    isOneClickBettingEnabled,
    tableRowTextColorClass = ''
  } = props;

  const marketEnableStatus = ["active", "open"];

  return (
    <>
      <TableRow className={`${tableRowTextColorClass} ${tableRowTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`}>
        <TableCell className={`team-name-cell ${tableRowTextColorClass} ${tableRowTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: tableRowTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
          <div className={`team ${tableRowTextColorClass} ${tableRowTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} style={{ color: tableRowTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
            {runner?.runnerName}
            {/* {getOpenBetsPL(matchOddsData.marketId, runner, 'array').map(
              (ret) =>
                ret !== null ? (
                  <span className={ret >= 0 ? 'profit' : 'loss'}>
                    {ret > 0
                      ? '+' + Number(ret).toFixed(2)
                      : Number(ret).toFixed(2)}
                  </span>
                ) : null
            )} */}
          </div>
          <div>
            {/* {getTotalPL(matchOddsData.marketId, runner).map((ret) =>
              ret !== null ? (
                <span className={ret >= 0 ? 'profit' : 'loss'}>
                  {ret > 0
                    ? '+' + Number(ret).toFixed(2)
                    : Number(ret).toFixed(2)}
                </span>
              ) : null
            )} */}
          </div>
        </TableCell>
        <TableCell className={`odds-cell ${tableRowTextColorClass} ${tableRowTextColorClass === 'dark-text' ? 'text-black' : 'text-white'}`} align="right" style={{ color: tableRowTextColorClass === 'dark-text' ? '#000000' : '#FFFFFF' }}>
          {/* <div className="odds-block web-view back-odds-block premium-odds-block">
            {runner?.backPrices?.length > 0 ? (
              runner?.backPrices?.map((odds :any, idx:any) => (
                <MarketOddBtn
                  mainValue={odds.price}
                  subValue={null}
                  showSubValueinKformat={true}
                  oddType="premium-odd"
                  valueType="matchOdds"
                  oddsSet={[
                    runner?.backPrices?.[0]
                      ? runner?.backPrices?.[0]?.price
                      : 0,
                    runner?.backPrices?.[1]
                      ? runner?.backPrices?.[1]?.price
                      : 0,
                    runner?.backPrices?.[2]
                      ? runner?.backPrices?.[2]?.price
                      : 0,
                  ]}
                  key={idx}
                  // disable={
                  //   disabledStatus.includes(
                  //     matchOddsData.status.toLowerCase()
                  //   ) ||
                  //   disabledStatus.includes(eventData.status.toLowerCase()) ||
                  //   odds?.price > limits?.maxOdd
                  // }
                //   onClick={() => {
                //     if (odds?.price < limits?.maxOdd) {
                //       addExchangeBet({
                //         sportId: dreamData.sportId,
                //         seriesId: dreamData.competitionId,
                //         seriesName: eventData.competitionName,
                //         eventId: dreamData.eventId,
                //         eventName: eventData.eventName,
                //         eventDate: +eventData.openDate,
                //         marketId: matchOddsData.marketId,
                //         marketName: matchOddsData.marketName,
                //         marketType: 'PREMIUM',
                //         outcomeId: runner?.runnerId,
                //         outcomeDesc: runner?.runnerName,
                //         betType: 'BACK',
                //         amount: 0,
                //         oddValue: runner?.backPrices?.[idx]?.price,
                //         sessionPrice: -1,
                //         srEventId: eventData.eventId,
                //         srSeriesId: eventData.competitionId,
                //         srSportId: eventData.sportId,
                //         mcategory: 'ALL',
                //       });
                //     }
                //   }}
                />
              ))
            ) : (
              <>
                <div className="exch-odd-view">
                  <div className={'premium-odd disabled exch-odd-button'}>
                    <LockOutlined className="lock-icon" />
                  </div>
                </div>
              </>
            )}
          </div> */}

          <div className="odds-block mob-view back-odds-block premium-odds-block">
            {runner?.backPrices?.length > 0 ? (
              <MarketOddBtn
                mainValue={runner.backPrices[0]?.price}
                subValue={null}
                showSubValueinKformat={true}
                oddType="premium-odd"
                valueType="matchOdds"
                disable={
                  disabledStatus.includes(eventData?.status?.toLowerCase()) ||
                  disabledStatus.includes(market?.status?.toLowerCase()) ||
                  !marketEnableStatus.includes(market?.status?.toLowerCase()) ||
                  !marketEnableStatus.includes(runner?.status?.toLowerCase())
                }
                onClick={() => {
                  setSelectedRow(runner.runnerName + 'PREMIUM');
                  addExchangeBet({
                    eventId: eventData?.providerName?.toLocaleLowerCase() === "sportradar" ?
                      eventData.eventId
                      : eventData?.markets?.premiumEventId,
                    eventName: eventData.eventName,
                    marketName: market.marketName,
                    marketId: market.marketId,
                    marketType: market.marketType,
                    oddValue: runner.backPrices[0]?.price,
                    runnerId: runner.runnerId,
                    runnerName: runner.runnerName,
                    competitionId: eventData.competitionId,
                    betType: "BACK",
                    sessionOutcome: 0,
                    stakeAmount: 0,
                    maxLimit: max,
                    minLimit: min,
                    sportId: eventData?.providerName?.toLocaleLowerCase() === "sportradar" ?
                      eventData?.sportId
                      : eventData?.markets?.premiumSportId,
                    provider: "SportRadar",
                  });
                }}
              />
            ) : (
              <>
                <div className="exch-odd-view">
                  <div className={'premium-odd disabled exch-odd-button'}>
                    <LockOutlined className="lock-icon" />
                  </div>
                </div>
              </>
            )}
          </div>
        </TableCell>
      </TableRow>

      {!isOneClickBettingEnabled && bets?.length > 0 &&
        bets?.[0]?.marketName === matchOddsData.marketName &&
        selectedRow === runner?.runnerName + 'PREMIUM' &&
        // isMobile ? (
        <TableRow className="mob-view inline-betslip">
          <TableCell colSpan={12}>
            <ExchBetSlip balance={0} exposure={0} />{' '}
          </TableCell>
        </TableRow>
        // ) : null}
      }
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    bets: state.exchBetSlip.bets,
    eventInfo: state.exchangeSports.eventInfo,
    isOneClickBettingEnabled: state.exchBetSlip.isOneClickBettingEnabled,
    userDetails: state.userDetails?.userDetails,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    addExchangeBet: (data: BsData) => dispatch(addExchangeBet(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PremiumMarketsView);
